import React from "react";
import Image from "@Components/Image";
import formatClassNames from "@Utils/clientUtils/stringUtility/formatClassNames";
import styles from "../ReviewsSectionStyles.module.scss";
import getImagePath from "@Utils/getImagePath";
import useImageWithFallback from "hooks/useImageWithFallback";
import { getVideoThumb } from "../../SectionFeatured.tsx/utils";
import wrapperHOC from "@Utils/wrapperHOC";

interface ReviewVideoThumbnailProps {
  img: any;
  index: number;
  isDesktop: boolean;
  review: any;
  handleMediaClick: any;
}

const ReviewVideoThumbnail: React.FC<ReviewVideoThumbnailProps> = ({
  img: media,
  index,
  isDesktop,
  review,
  handleMediaClick,
}) => {
  const fallbackUrl = getImagePath(
    "https://s3.ap-southeast-1.amazonaws.com/static-assets.amberstudent.com/images/video_thumbnail.png",
    "thumbnail-normal",
    {},
    false,
    true,
  );

  const videoThumb = getVideoThumb(media, { height: 88, width: 88 });
  const resolvedThumb = useImageWithFallback(videoThumb, fallbackUrl);

  return (
    <div
      className={styles.mediaOverlayContainer}
      role="none"
      onClick={handleMediaClick}
      key={`ReviewCardVideo${index}`}
    >
      <div className={styles.videoThumbnailContainer} role="none">
        <Image
          className={formatClassNames(styles.topThumbnails, isDesktop && styles.desktop)}
          src={resolvedThumb || fallbackUrl}
          height={64}
          width={64}
        />
        <div className={styles.videoPlayButtonContainer}>
          <div className={styles.videoPlayButtonInner}>
            <div className={styles.videoPlayButtonTriangle} />
          </div>
        </div>
      </div>
      {index === 3 ? (
        <div className={styles.mediaOverlay}>
          <div className={styles.plusText}>
            +{review?.images.length + review?.videos.length - 4}
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default wrapperHOC(ReviewVideoThumbnail, {
  componentName: "ReviewVideoThumbnail-PropertyPage",
  showForChina: true,
});
